import * as fromActions from '../actions/access.action'
import { ICoursePermissions } from '../states/access.state'

import { Reducer } from 'redux'

export const initialState: any = {
  courses: [] as ICoursePermissions[],
}

export const reducer: Reducer<any> = (state: any = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.CAN_COURSE:
      return {
        ...state,
        courses: {
          ...state.courses,
          [payload]: {
            loading: true,
          },
        },
      }

    case fromActions.CAN_COURSE_SUCCESS:
      return {
        ...state,
        courses: {
          ...state.courses,
          [payload.id]: { ...payload, loading: false },
        },
      }

    default:
      return state
  }
}
